import type { Content, RichContent } from '@/types/content';

export function getImages(content: Content): RichContent[] {
  return content?.RichContent?.filter((cont) => cont.type.toLowerCase() === 'image') || [];
}

export function getHeaderImage(content: Content): string {
  return content?.RichContent?.filter((cont) => cont.subType?.toLowerCase() === 'header')[0]?.path ?? '';
}
